module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Definition et diagnostic des pneumopathies.744ea1fa07fff41ab067aa945bc42269.pdf";